import { ReactNode } from 'react';
import Typography from '@mui/material/Typography';
import Stack, { StackProps } from '@mui/material/Stack';

export interface PropertyItemProps {
  label: ReactNode;
  value: ReactNode;
  direction?: StackProps['direction'];
}

export const PropertyItem = ({ label, value, direction = 'row' }: PropertyItemProps) => {
  const isValueEmpty = value === null || value === undefined || value === '';
  return (
    <Stack direction={direction} justifyContent="space-between" gap={3}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      {isValueEmpty ? (
        <Typography variant="body2" color="textDisabled">
          -
        </Typography>
      ) : (
        <Typography variant="body2" textAlign="right" component="div">
          {value}
        </Typography>
      )}
    </Stack>
  );
};
